import { useQuery } from "@tanstack/react-query";
import type { AgeClassification } from "../../../api/client/types/age-classification.types";
import type { ApiError } from "../../../api/client/types/common.types";
import { ageClassificationEndpoints } from "../../../api/endpoints/age-classification";

/**
 * React Query Keys
 * Organized keys help with cache invalidation and devtools debugging.
 */
const ageClassificationQueryKeys = {
  root: ["age-classifications"] as const,
  list: () => [...ageClassificationQueryKeys.root, "list"] as const,
  detail: (id: number) => [...ageClassificationQueryKeys.root, "detail", id] as const,
};

/**
 * Hook: useGetAgeClassifications
 * Fetches all age classifications.
 */
export const useGetAgeClassifications = () => {
  return useQuery<AgeClassification[], ApiError>({
    queryKey: ageClassificationQueryKeys.list(),
    queryFn: () => ageClassificationEndpoints.getAgeClassifications(),
  });
};

export const useGetAgeClassificationById = (id: number) => {
  return useQuery<AgeClassification, ApiError>({
    queryKey: ageClassificationQueryKeys.detail(id),
    queryFn: () => ageClassificationEndpoints.getAgeClassificationById(id),
  });
};